import { addContextHeaderEvent } from "../common/context-header-event";
class ContextHeader extends lm.Composant {
  constructor(componentName) {
    super(componentName);
    addContextHeaderEvent();
  }
}
lm.DOMReady(() => {
  new ContextHeader('contextheader');
});